import type { TWeddingWebsiteQueryData } from './website/use-wedding-website';

export const getIsWeddingWebsiteCreated = (data: TWeddingWebsiteQueryData) => Boolean(data);

export const getIsWeddingWebsitePublished = (data: TWeddingWebsiteQueryData) =>
  data?.privacy.published;

export const getWeddingWebsiteId = (data: TWeddingWebsiteQueryData) => data?.id;

export const getWeddingWebsiteTheme = (data: TWeddingWebsiteQueryData) => data?.config.theme;

export const getWeddingWebsiteHasPassword = (data: TWeddingWebsiteQueryData) =>
  Boolean(data?.privacy.pin);

export const getWeddingWebsiteFlags = (data: TWeddingWebsiteQueryData) => ({
  isCreated: getIsWeddingWebsiteCreated(data),
  isPublished: getIsWeddingWebsitePublished(data),
  hasPassword: getWeddingWebsiteHasPassword(data),
});

export const getWeddingWebsitePassword = (data: TWeddingWebsiteQueryData) => data?.privacy.pin;
